import { useEffect } from "react";
import { Descriptions, Form, Row } from "antd";
import { SearchBar } from "Components/General/SearchBar";
import { useTranslation } from "react-i18next";
import { Button } from "Components/General/Button";
import { observer } from "mobx-react";
import { objectsAndDataStore } from "../Stores/ObjectsAndDataStore";
import { withModal, WithModal } from "Components/General/Modal/withModal";
import { CreateNewObjectTypeModal } from "../Components/CreateNewObjectTypeModal";
import { dayjs } from "Config/dayjs";
import { Loader } from "Components/General/Loader";
import { I18N_NS } from "Config/i18n";
import { useNavigate, useParams } from "react-router-dom";

interface ObjectsAndDataInfoProps extends WithModal {}

export const ObjectsAndDataInfo = withModal(
  observer(({ showModal }: ObjectsAndDataInfoProps) => {
    const { t } = useTranslation(I18N_NS.PROJECT);
    const params = useParams();
    const navigate = useNavigate();
    useEffect(() => {
      objectsAndDataStore.fetch(+params.id);
    }, [params.id]);

    const listOfReferences = objectsAndDataStore.singleData?.referencedTables.map((item) => {
      return (
        // <DescriptionsItem label={item?.name + ":"}>{item?.description}</DescriptionsItem>
        <div key={item.id}>
          <p style={{ fontWeight: "bold" }}>{item?.name + ": "}</p>
          <p>{item?.description}</p>
        </div>
      );
    });

    const createObjectModal = () => {
      showModal(CreateNewObjectTypeModal, {
        modalProps: {
          footer: null,
          width: 800,
          title: t("New {{name}}", { name: objectsAndDataStore.singleData?.nameSingleObject }),
          maskClosable: false,
        },
        componentProps: {
          createNewAttributes: objectsAndDataStore.createNewAttributes,
          tableId: objectsAndDataStore.singleData?.id,
          attributes: objectsAndDataStore.singleData?.attributes,
        },
      });
    };

    const handleSearch = async (value: string) => {
      try {
        navigate(`search-results?${value}`);
        // await objectsAndDataStore.submitSearch(+match.params.id, value);
      } catch (error) {
        throw error;
      }
    };
    const searchAttributes = objectsAndDataStore.singleData?.attributes
      ?.filter((item) => item.quicksearch)
      ?.map((item) => item.name)
      ?.slice(0, 5)
      ?.join(", ");

    return (
      <>
        <Row justify="space-between" style={{ flexWrap: "nowrap", flexDirection: "row", paddingBottom: 20 }}>
          <Form
            style={{ width: "100%", flexWrap: "nowrap", flexDirection: "row", display: "flex" }}
            onSubmitCapture={(e) => e.preventDefault()}
          >
            <SearchBar
              placeholder={t("Search in {{attributes}}", { attributes: searchAttributes })}
              onSearch={handleSearch}
              autoFocus={true}
              style={{ marginRight: 10, marginBottom: 0 }}
            />
            <Button
              disabled={!objectsAndDataStore.singleData?.hasWriteAcl}
              faIcon="plus"
              type="primary"
              onClick={createObjectModal}
            >
              {t("New {{name}}", { name: objectsAndDataStore.singleData?.nameSingleObject })}
            </Button>
          </Form>
        </Row>
        <Row>
          {objectsAndDataStore.state === "LOADING" ? (
            <Loader />
          ) : (
            <Descriptions
              layout="horizontal"
              className="mb-2"
              size="middle"
              bordered
              title={objectsAndDataStore.singleData?.name}
            >
              <Descriptions.Item label={t("Number of entries:")}>
                {objectsAndDataStore.singleData?.entryCount}
              </Descriptions.Item>
              <Descriptions.Item label={t("Last change:")}>
                {objectsAndDataStore.singleData?.lastUpdated
                  ? dayjs(objectsAndDataStore.singleData?.lastUpdated).format("LLL")
                  : ""}
              </Descriptions.Item>
              <Descriptions.Item label={t("Number of attributes:")}>
                {objectsAndDataStore.singleData?.attributeCount}
              </Descriptions.Item>
              <Descriptions.Item label={t("Linked objects:")}>{listOfReferences}</Descriptions.Item>
            </Descriptions>
          )}
          {/* <Card title={objectsAndDataStore.singleData?.name} style={{ width: "100%" }}>
            <p>Number of entries: {objectsAndDataStore.singleData?.entryCount}</p>
            <p>Last change: {objectsAndDataStore.singleData?.lastUpdated}</p>
            <p>Number of attributes: {objectsAndDataStore.singleData?.attributeCount}</p>
            <p>Linked objects: </p>
            {listOfReferences}
          </Card> */}
        </Row>
      </>
    );
  })
);
